import { DefaultButton } from "components/Shared/DefaultButton";
import { useRecallFixtureTask } from "hooks/useFixtureTaskApi";
import { useRecallSeasonTask } from "hooks/useSeasonTaskApi";
import { useIntl } from "react-intl";

type Props = {
  entityId: string;
  season?: any;
  fixture?: any;
};

export const RecallButton = ({ entityId, season, fixture }: Props) => {
  const { formatMessage } = useIntl();
  const { mutate: recallSeasonTask, isPending: isSeasonTaskRecalling } = useRecallSeasonTask();
  const { mutate: recallFixtureTask, isPending: isFixtureTaskRecalling } = useRecallFixtureTask();

  const disabled = fixture ? !fixture.isRegistrationOpened : !season.isRegistrationOpened;

  const onReview = () => {
    if (fixture) {
      recallFixtureTask({
        entityId: entityId,
        seasonId: fixture.seasonId,
        fixtureId: fixture.fixtureId,
      });
    } else if (season) {
      recallSeasonTask({ entityId: entityId, seasonId: season.seasonId });
    }
  };

  return (
    <DefaultButton
      disabled={disabled}
      loading={isSeasonTaskRecalling || isFixtureTaskRecalling}
      onClick={onReview}
      icon={<i className="fa-solid fa-arrow-rotate-left"></i>}
    >
      {formatMessage({ id: "button.recall" })}
    </DefaultButton>
  );
};
